import React from "react";
// Import necessary dependencies and components.
import { motion } from "framer-motion";

import SectionHeading from "./section-heading";
import { useSectionInView } from "../lib/hooks";

// Define the About component.
const About = () => {
  // Use the useSectionInView custom hook to track when the "About" section is in view.
  const { ref } = useSectionInView("About");

  // Return the About section, which uses framer-motion for animations.
  return (
    <motion.section
      ref={ref}
      id="about"
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.175 }}
      className="mb-28 max-w-[80rem] text-center leading-8 sm:mb-40 scroll-mt-28"
    >
      {/* Display the section heading for "About me." */}
      <SectionHeading>About me</SectionHeading>

      {/* Display a paragraph with information about the user's background and interests. */}
      <div>
        <p>
          Hey there, I'm <b className="font-medium">Ashish Patel</b>, a{" "}
          <b className="font-medium">Senior Software Developer</b> with a love
          for creating amazing web and mobile applications. With over 7 years
          of experience, I've mastered{" "}
          <b className="font-medium">JavaScript, Python, PHP, and TypeScript</b>
          , and enjoy working with technologies like{" "}
          <b className="font-medium">
            NodeJs, ReactJs, Angular, Docker, and more
          </b>
          . I'm passionate about writing clean, efficient code and staying on
          top of the latest tech trends.
        </p>
        <p>
          When I'm not coding, you can find me diving into the world of PC games
          or enjoying a game of cricket outdoors. I believe in a healthy balance
          between work and play, and these hobbies keep me refreshed and ready
          to tackle new challenges in the tech world!
        </p>
      </div>
    </motion.section>
  );
};

// Export the About component.
export default About;
